// Utilidades para formatear fechas
export const formatDate = (dateInput, options = {}) => {
  if (!dateInput) return 'No especificado';
  
  try {
    let dateString;
    let timeZone = 'America/Bogota';
    
    // Manejar diferentes formatos de entrada
    if (typeof dateInput === 'object') {
      if (dateInput.dateTime) {
        // Formato del backend: {dateTime: '2025-09-18T15:00:00-05:00', timeZone: 'America/Bogota'}
        dateString = dateInput.dateTime;
        timeZone = dateInput.timeZone || timeZone;
      } else if (dateInput.date) {
        // Formato de fecha completa: {date: '2025-09-18'}
        dateString = dateInput.date;
      } else if (dateInput._d) {
        // Formato Moment.js
        dateString = dateInput._d;
      } else {
        // Intentar convertir el objeto directamente
        dateString = dateInput.toString();
      }
    } else if (typeof dateInput === 'string') {
      // Formato string directo
      dateString = dateInput;
    } else {
      console.log('Formato de fecha no reconocido:', dateInput);
      return 'Formato de fecha no soportado';
    }
    
    const date = new Date(dateString);
    
    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
      console.log('Fecha inválida:', dateString);
      return 'Fecha inválida';
    }
    
    // Opciones por defecto para formato español
    const defaultOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timeZone,
      ...options
    };
    
    return date.toLocaleString('es-CO', defaultOptions);
  } catch (error) {
    console.error('Error formateando fecha:', error, dateInput);
    return 'Fecha inválida';
  }
};

export const formatDateShort = (dateString) => {
  return formatDate(dateString, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateOnly = (dateString) => {
  return formatDate(dateString, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatTimeOnly = (dateString) => {
  return formatDate(dateString, {
    hour: '2-digit',
    minute: '2-digit'
  });
};